import { get } from 'lodash';

const userDataSelector = (state) => state.userAuth.user;
const merchantIdSelector = (state) =>
	get(state, 'merchantProfile.merchantDetails.merchantId');
const merchantOnboardingStageSelector = (state) =>
	get(state, 'merchantProfile.onboardingInfo.onboardingStage');
export {
	userDataSelector,
	merchantIdSelector,
	merchantOnboardingStageSelector,
};
